// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"645":"365fd541","787":"63a3d4ac","800":"4fd0bd83"}[chunkId] + ".chunk.js";
};